import React from "react";
import Header from "../components/Header";
import GoalsSection from "../components/GoalsSection";
import StatisticsSection from "../components/StatisticsSection";
import Footer from "../components/Footer";

import "../styles/App.css";

function Home() {
  return (
    <div className="Home">
      <Header />
      <GoalsSection />
      <StatisticsSection />
      <Footer />
    </div>
  );
}

export default Home;
